import styled from 'styled-components';

import { fadeIn } from '../../styles/shared.style';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 16px 0;
  animation: ${fadeIn} 0.5s forwards;
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  overflow: hidden;
`;

export const GroupHeader = styled.div<{ $opened: boolean }>`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 20px;
  background-color: ${({ theme }) => theme.colors.surface.high};
  cursor: pointer;
  user-select: none;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.accent.primary};
    outline-offset: -2px;
  }
`;

export const GroupHeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const GroupTitleRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;

  @media (min-width: 1200px) {
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
`;

export const GroupName = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  letter-spacing: 0.016em;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const GroupCount = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  letter-spacing: 0.016em;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const CircularArrow = styled.span<{ $opened: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.surface.low};
  border: 1.5px solid ${({ theme }) => theme.colors.border};
  font-size: 11px;
  color: ${({ theme }) => theme.colors.text.secondary};
  transform: ${({ $opened }) => ($opened ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.3s ease;
`;

export const GroupBody = styled.div<{ $opened: boolean }>`
  background-color: ${({ theme }) => theme.colors.surface.low};
  max-height: ${({ $opened }) => ($opened ? '500px' : '0')};
  padding: ${({ $opened }) => ($opened ? '16px 20px' : '0 20px')};
  overflow: hidden;
  transition: max-height 0.5s ease, padding 0.5s ease;
`;

export const ItemList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const Item = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.surface.high};
    margin: 0 -20px;
    padding-left: 20px;
    padding-right: 20px;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.accent.primary};
    outline-offset: 2px;
  }
`;

export const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
`;

export const ItemName = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16.94px;
  letter-spacing: 0.016em;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const ItemCount = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  letter-spacing: 0.016em;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ItemLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ItemPrice = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 19.36px;
  letter-spacing: 0.016em;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const ItemFees = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.52px;
  letter-spacing: 0.016em;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const StockBadge = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 4px;
  height: 28px;
  padding: 0 12px;
  border-radius: 28px;
  background-color: ${({ theme }) => theme.colors.accent.primary};
  color: #ffffff;
  white-space: nowrap;
  font-family: 'Elza', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.016em;
`;
